'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import I18nContext from './context/I18nContext'; // Imports info on what base locales we support in I18n
// Usually used in Language/Locale selects

import 'I18n/init/data/baseLocales'; // Imports info on what extra locales we support in I18n
// (ie languages we support for our user's users)
// Usually used in Language/Locale selects

import 'I18n/init/data/publicLocales'; // Imports all currency data
// Needed if you render currency anywhere

import 'I18n/init/data/currency';
import UIApplication from 'UIComponents/app/UIApplication';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client'; // Rhumb

import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4'; // Redux

import { Provider } from 'react-redux';
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { startApp } from './actions/AppActions';
import { getCollections } from './actions/CollectionsActions';
import configureStore from './utils/configureStore'; // Configure the router

import { Router } from 'react-router-dom';
import Routes from './components/Routes';
import { setApiClient } from './utils/apiClient';
import { setUsageTracker } from './utils/usageTracker';
import isThenable from 'hs-promise-utils/isThenable';
import { createHistory } from './utils/history';
import { debug, setDebugGate, setDebug, logDebugging } from './utils/env';
import WindowDimensionsProvider from 'ecosystem-marketplace-core/components/providers/WindowDimensionsProvider';
import MediaQueryStylesProvider from 'ecosystem-marketplace-core/components/layout/MediaQueryStylesProvider';
import HSAnalyticsProvider from 'ecosystem-marketplace-core/components/tracking/HSAnalyticsProvider';
import FeedbackSurveyLoader from './components/FeedbackSurveyLoader';
const dataFetchingClient = new DataFetchingClient();
export default class App {
  constructor({
    apiClient,
    appName,
    rhumbConfig,
    rootUrl,
    usageTracker,
    ApplicationComponent = UIApplication,
    RoutesComponent = Routes,
    blockingActions = [],
    isAdminPreview = false,
    isPublic = false,
    I18nProvider
  }) {
    this.setDebug = (key, ...args) => setDebug(key, ...args);

    this.setDebugGate = (gate, ...args) => setDebugGate(gate, ...args);

    setApiClient(apiClient);
    setUsageTracker(usageTracker);
    this.ApplicationComponent = ApplicationComponent;
    this.appName = appName;
    this.blockingActions = blockingActions;
    this.isAdminPreview = isAdminPreview;
    this.isPublic = isPublic;
    this.rhumbConfig = rhumbConfig;
    this.rootUrl = rootUrl;
    this.I18nProvider = I18nProvider;
    this.RoutesComponent = RoutesComponent;
  }

  start() {
    if (debug()) {
      window.appInstance = this;
      logDebugging();
    }

    const storeReady = this.startRedux();
    const langAvailable = Promise.all([this.I18nProvider.register(lang), registerAllData(this.I18nProvider)]);
    storeReady.then(() => {
      if (!(this.isPublic || this.isAdminPreview)) {
        const {
          user
        } = this.store.getState().auth;
        this.I18nProvider.setLocale({
          locale: user.locale,
          langEnabled: user.lang_enabled
        });
      }

      return langAvailable.then(() => {
        this.store.dispatch(startApp());
        this.startRouter(this.I18nProvider);
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  }

  startRedux() {
    this.store = configureStore();
    const promises = [];
    this.blockingActions.forEach(actionCall => {
      const maybePromise = this.store.dispatch(actionCall());

      if (isThenable(maybePromise)) {
        promises.push(maybePromise);
      }
    });
    return Promise.all(promises).then(() => {
      const collectionsRegex = new RegExp(/collections\/(\d*)/);
      const previewCollectionId = this.isAdminPreview && collectionsRegex.test(window.location.href) && window.location.href.match(collectionsRegex)[1];
      return this.store.dispatch(getCollections(this.isAdminPreview, previewCollectionId));
    });
  }

  startRouter(i18nProvider) {
    const {
      ApplicationComponent,
      RoutesComponent,
      rootUrl
    } = this;
    this.history = createHistory(rootUrl);
    render( /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: this.rhumbConfig,
          history: historyAdapter(this.history),
          children: /*#__PURE__*/_jsx(I18nContext.Provider, {
            value: i18nProvider,
            children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
              children: /*#__PURE__*/_jsx(MediaQueryStylesProvider, {
                children: /*#__PURE__*/_jsxs(WindowDimensionsProvider, {
                  children: [/*#__PURE__*/_jsx(Router, {
                    history: this.history,
                    children: /*#__PURE__*/_jsxs(ApplicationComponent, {
                      name: this.appName,
                      children: [/*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(RoutesComponent, {})]
                    })
                  }), !this.isAdminPreview && /*#__PURE__*/_jsx(FeedbackSurveyLoader, {
                    isPublic: this.isPublic
                  })]
                })
              })
            })
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  } // Debug methods


}